import { FC } from "react";

const PricingSection: FC = () => {
  return (
    <section className="py-32 px-6">
      <div className="max-w-[70%] mx-auto grid md:grid-cols-2 gap-8 items-center">
        {/* Texto informativo */}
        <div className="w-[100%]">
          <h2 className="text-[40px] font-bold text-gray-900 mb-4">
            Beneficios que puede experimentar con nuestras opciones de precios
          </h2>
          <p className="text-gray-600 leading-8">
            Consulta nuestras sencillas opciones de precios: elige un pago único
            para ahorrar rápidamente o un plan mensual para realizar pagos más
            pequeños y sencillos. De cualquier manera, obtienes un gran valor y
            un servicio excelente sin gastar una fortuna.
          </p>
        </div>

        {/* Tarjetas de precios */}
        <div className="flex flex-col md:flex-row gap-12 justify-center items-center">
          <div className="bg-bgSecundary text-white py-6 px-4 rounded-xl shadow-lg w-80 text-center">
            <h3 className="text-[25px] font-semibold py-4">Pago mensual</h3>
            <p className="text-gray-300 text-sm">
              Disfruta tu servicio sin compromisos y con total flexibilidad.
            </p>
            <div className="text-[38px] font-bold my-6">$49.900</div>
            <ul className="text-gray-300 text-sm space-y-4 mb-4">
              <li>✔ Control de pasajeros en ruta</li>
              <li>✔ Geolocalización en tiempo real</li>
              <li>✔ Programación de rutas</li>
              <li>✔ Panel de administrador</li>
            </ul>
            <button className="bg-white text-gray-900 px-4 py-4 mt-6 rounded-lg font-semibold w-full">
              SUSCRÍBETE
            </button>
          </div>

          {/* Plan Anual */}
          <div className="bg-white text-textSecundary border border-bgSecundary p-6 rounded-xl shadow-lg w-80 text-center">
            <h3 className="text-[25px] font-semibold py-4">Pago Anual</h3>
            <p className="text-gray-600 text-sm">
              Disfruta tu servicio todo el año sin preocupaciones.
            </p>
            <div className="text-[38px] font-bold my-6">$508.800</div>
            <ul className="text-gray-600 text-sm space-y-4 mb-4">
              <li>✔ Control de pasajeros en ruta</li>
              <li>✔ Geolocalización en tiempo real</li>
              <li>✔ Programación de rutas</li>
              <li>✔ Panel de administrador</li>
            </ul>
            <button className="bg-bgSecundary text-white px-4 py-4 mt-6 rounded-lg font-semibold w-full">
              SUSCRÍBETE
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PricingSection;
